import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import {
  EVENT_LIST_CACHE_FIELDS,
  ORGANIZATION_PEOPLE_CACHE_FIELDS,
} from '@/client/exchanges/cacheExchange/constants';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function delete_event_by_pk(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(
    [...EVENT_LIST_CACHE_FIELDS, ...ORGANIZATION_PEOPLE_CACHE_FIELDS],
    cache,
  );
}
